import type { CollectibleId } from "@/services/collectibles";
import type { CollectibleElastic } from "@/services/collectibles/elastic";
import type { CategoryId } from "@/services/collection/categories";
import type { ItemStatus } from "@/services/collection/item/collectionItemTypes";
import { type CollectionItemId } from "@/services/collection/item/collectionItemTypes";
import type { PublicCollectionItem_Basics_Schema, PublicCollectionItem_FeaturedListItem_Schema, PublicCollectionItem_FromCollectible_Schema, PublicCollectionItem_ListItem_Schema, PublicCollectionItem_SearchListItem_Schema } from "@/services/collection/item/public/publicCollectionItemSchema";
import type { CollectorId } from "@/services/collectors";
import type { ApiResponseImageNoId } from "@/services/images";
import type { MarketplaceItem } from "@/services/marketplace/item";
import type { Price } from "@/services/prices";
import type { z } from "zod";

/** @deprecated Should be replaced by CollectionItemElastic. */
export type PublicCollectionItem = {
  id: CollectionItemId;
  categoryId: CategoryId;
  name: string;
  collectorNickname: string;
  publishedDate: string; // expected YYYY-MM-DD
  marketplaceListedDate?: string; // expected YYYY-MM-DD
  publicNote: string;
  catalogueItemParams: {
    label: string;
    value: string | number;
  }[];
  collectorId: CollectorId;
  collectorItemsCount: number;
  collectorRating: number;
  collectorRatingsCount: number;
  collectorAvatar: string | null;
  publicPrice: Price;
  publicPriceBeforeConversion: Price;
  status: ItemStatus;
  images: ApiResponseImageNoId[];
  likesCount: number;
  likedByCurrentUser: boolean;
  collectible: {
    id: CollectibleId;
    name: string;
  } | null;
  collectibleElastic: CollectibleElastic | null;
  marketPlaceItem: MarketplaceItem | null;
};

/** @deprecated Should be replaced by CollectionItemElastic. */
export type PublicCollectionItem_CreatedFromCollectible = PublicCollectionItem & {
  collectible: {
    id: CollectibleId;
    name: string;
  };
};

export class PublicItemNotFoundException extends Error {}

export type PublicCollectionItem_ListItem = z.infer<typeof PublicCollectionItem_ListItem_Schema>;
export type PublicCollectionItem_SearchListItem = z.infer<typeof PublicCollectionItem_SearchListItem_Schema>;
export type PublicCollectionItem_FeaturedListItem = z.infer<typeof PublicCollectionItem_FeaturedListItem_Schema>;

export type PublicCollectionItem_FromCollectible = z.infer<typeof PublicCollectionItem_FromCollectible_Schema>;

export type PublicCollectionItem_Basics = z.infer<typeof PublicCollectionItem_Basics_Schema>;

// List item with marketplace data (for sale items)
export type PublicCollectionItem_ListItem_ForSale = PublicCollectionItem_ListItem & {
  marketplaceItem: NonNullable<PublicCollectionItem_ListItem["marketplaceItem"]>;
};
